// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_REMOVED_BUYERS = "Odstran\u011bn\u00ed z\u00e1jemci";
export const BZ2_RESTORE_BUYER = "Obnov z\u00e1jemce";
